module.exports = __webpack_public_path__ + "static/media/ep1.96b6362d.jpg";